import { useCallback, useEffect, useState } from 'react';
import { fetchWorkspaceTargets, type WorkspaceTargets } from '@/services/targets/targetsService';
import { logError } from '@/services/logger';

export type WorkspaceTargetsState = { status: 'loading' } | { status: 'failed' } | { status: 'ready'; data: WorkspaceTargets };

export const useWorkspaceTargets = (workspaceId: string | null): { state: WorkspaceTargetsState; reload: () => void } => {
  const [state, setState] = useState<WorkspaceTargetsState>({ status: 'loading' });
  const [tick, setTick] = useState(0);
  const reload = useCallback(() => setTick((n) => n + 1), []);
  useEffect(() => {
    if (!workspaceId) return;
    let ignore = false;
    fetchWorkspaceTargets(workspaceId).then(
      (data) => { if (!ignore) setState({ status: 'ready', data }); },
      (err: unknown) => {
        logError('useWorkspaceTargets', 'targets read failed', err);
        if (!ignore) setState({ status: 'failed' });
      },
    );
    return () => { ignore = true; };
  }, [workspaceId, tick]);
  return { state, reload };
};
